var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column-container"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"items"},_vm._l((_vm.list),function(it,index){return _c('item',{key:index,attrs:{"data":it}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }